import type { Quotation } from '../types/sales/quotation';

export const quotationRowKey = (q: Quotation): string => String(q.id);

export interface QuotationTotals {
  count: number;
  totalAmount: number;
  balance: number;
}

export const computeQuotationTotals = (rows: Quotation[]): QuotationTotals => {
  let totalAmount = 0;
  for (const row of rows) {
    totalAmount += parseFloat(row.total_amount) || 0;
  }
  return {
    count: rows.length,
    totalAmount,
    balance: 0,
  };
};
